export default __webpack_public_path__ + "static/media/heat-4.66d2ca41.png";